export default __webpack_public_path__ + "media/images/bg_login-23d0ba5ad7d40e5e687f58b6e2e13a0c.jpg";